import { useMemo } from "react";
import { Timesheet as TimesheetEntry } from "src/api/Timesheet";
import { timesheetService } from "src/service/TimesheetService";
import { useProjectNames } from "@/hooks/useProjectNames";
import TimesheetDialog from "src/pages/timesheet/TimesheetDialog";
import { toaster } from "@/components/ui/toaster";
import { createDraftEntry } from "src/pages/timesheet/components/TimesheetCalendarUtils";
import type { TimerStopData } from "./TimerContext";

interface TimerStopDialogProps {
  timerData: TimerStopData;
  open: boolean;
  onClose: () => void;
}

const TimerStopDialog = ({ timerData, open, onClose }: TimerStopDialogProps) => {
  const { options: projectNames } = useProjectNames();

  const draftEntry = useMemo(() => createDraftEntry({
    day: new Date(timerData.startedAt),
    userId: timerData.userId,
    organizationId: timerData.organizationId,
    startTime: timerData.startedAtTime,
    endTime: timerData.stoppedAtTime,
    minutes: timerData.elapsedMinutes,
  }), [timerData]);

  const handleSave = async (data: TimesheetEntry) => {
    data.userId = timerData.userId;
    data.organizationId = timerData.organizationId;
    await timesheetService.add(data);
    toaster.create({ title: "Zeiteintrag erfasst", type: "success" });
  };

  return (
    <TimesheetDialog
      projectNames={projectNames}
      isOpen={open}
      onClose={onClose}
      entry={draftEntry}
      onSave={handleSave}
      onDelete={() => {}}
      onApprove={() => {}}
      onReject={() => {}}
      canEdit={true}
      canCancel={false}
      canApprove={false}
      canReject={false}
    />
  );
};

export default TimerStopDialog;
